import { InvoiceType, ShipmentType } from '../enums'

export class InvoiceFilterOption {
  customerId: number;
  invoiceId: number;
  parentInvoiceId: number;
  shipmentId: number;
  type: InvoiceType;
  invoiceCode: string;
  shipmentCode: string;
  shippingMethod: ShipmentType;
  status: string;
  customerName: string;
  shipmentMethod: any;
  isSent: boolean;
  searchKey: string;
  deliveryType: string;
  bolNumber: string;
  franchiseeId: number;
  isFromGlobalSearch: boolean;
  isOtherShipment: boolean;
  countryId : any;
}